import { useQuery, useQueryClient } from 'react-query';

import { ParsedUrlQuery, encode } from 'querystring';
import { useState } from 'react';
import {
  DELETE,
  GET,
  POST,
  PUT,
  absenceType,
  createActiveTask,
  createTaskType,
} from 'utils';
import { api } from 'utils/apiRoutes';

const useMember = () => {
  const [users, setUsers] = useState();
  const [listsRequest, setListsRequest] = useState();
  const [state, setState] = useState({
    tasks: [],
    workShiftListFilter: [],
    holidayFilter: [],
    absenceTypes: [],
    absenceRequestCalendar: [],
  });
  const {
    tasks,
    workShiftListFilter,
    holidayFilter,
    absenceTypes,
    absenceRequestCalendar,
  } = state;

  const queryClient = useQueryClient();
  const departmentList = useQuery('get-department-list', getDepartmentList, {
    refetchOnWindowFocus: false,
  });

  const serviceList = useQuery('get-list-request', getServiceList, {
    refetchOnWindowFocus: false,
  });

  async function getWorkshiftList() {
    const res = await GET(api.workShiftList);
    setState((pre) => ({
      ...pre,
      workShiftListFilter: res?.data?.results,
    }));
    return await res?.data;
  }
  async function getWorkshiftListOption() {
    const res = await GET('/api/workshift-policy/option/');
    return await res?.data;
  }

  async function getStaffLeaveList(params?: ParsedUrlQuery) {
    return await GET(`${api.staffLeaveList}?${encode(params)}`);
  }
  async function getStaffLeaveListOption() {
    return await GET(`${api.getAbsencePolicyOption}`);
  }

  async function getFilterListBoarding(params: ParsedUrlQuery) {
    return GET(`${api.getListBoarding}?${encode(params)}`);
  }

  async function getListBoarding() {
    return await GET(api.getListBoarding);
  }

  async function getAllActiveTask() {
    return await GET(api.getAllActiveTask);
  }

  async function getDepartmentList() {
    return await GET(api.departmentList);
  }

  async function getAbsenceBalance() {
    const res = await GET(api.getAbsenceBalance);
    return res?.data?.results;
  }
  async function getMyBalanceOption() {
    return await GET(api.getBalanceOption);
  }

  async function getUsersList() {
    const res = await GET(api.usersList);
    setUsers(res?.data?.results);
    return res?.data?.results;
  }
  async function getListRequestApproval(param?: ParsedUrlQuery) {
    const res = await queryClient.fetchQuery('filter-product', () =>
      GET(`${api.getListRequestApproval}?${encode(param)}`),
    );
    // const res = await GET(api.getListRequestApproval);
    return res?.data;
  }

  async function getAbsenceTypesList(param?: ParsedUrlQuery) {
    const res = await queryClient.fetchQuery('filter-product', () =>
      GET(`${api.getAbsenceTypes}?${encode(param)}`),
    );
    setState((pre) => ({
      ...pre,
      absenceTypes: res?.data?.results,
    }));
    return res?.data;
  }
  async function getAbsenceTypesListAll() {
    const res = await queryClient.fetchQuery('get-absence-type', () =>
      GET(`${api.getAllAbsenceTypes}`),
    );
    return res;
  }

  async function getFilterUsers(query: ParsedUrlQuery) {
    const res = await queryClient.fetchQuery('filter-product', () =>
      GET(`${api.usersList}?${encode(query)}`),
    );
    setUsers(res?.data?.results);

    return res.data;
  }

  async function getFilterWorkShiftCalendars(params: ParsedUrlQuery) {
    const res = await queryClient.fetchQuery('filter-workshift-policy', () =>
      GET(`${api.workShiftList}?${encode(params)}`),
    );
    setState((pre) => ({
      ...pre,
      workShiftListFilter: res?.data?.results,
    }));

    return res;
  }

  async function getFilterTasks(query: ParsedUrlQuery) {
    const res = await queryClient.fetchQuery('filter-tasks', () =>
      GET(`${api.getTasksList}?${encode(query)}`),
    );
    setState((pre) => ({
      ...pre,
      tasks: res?.data?.results,
    }));
    return res?.data;
  }
  async function getAbsenceCalendar(query: string | number) {
    const res = await queryClient.fetchQuery('filter-tasks', () =>
      GET(`${api.getAbsenceRequestCalendar}?month=${query}`),
    );
    setState((pre) => ({
      ...pre,
      absenceRequestCalendar: res?.data?.results,
    }));
    return res?.data?.results;
  }

  async function getManagers(query?: ParsedUrlQuery) {
    let res = null;
    try {
      res = await queryClient.fetchQuery('filter-manager', () =>
        GET(`${api.managerList}?${encode(query)}`),
      );
    } catch (error) {
      res = error;
      console.log('error', error);
    }
    return res;
  }

  async function getUserById(param?: string) {
    const res = await GET(`${api.usersList}${param}`);
    return res;
  }

  async function getService(query: ParsedUrlQuery) {
    const res = await queryClient.fetchQuery('fetch-service', () =>
      GET(`${api.serviceList}?${encode(query)}`),
    );
    return res;
  }
  async function getServiceList() {
    const res = await GET(api.getService);
    return res;
  }

  async function filterListRequest(query?: ParsedUrlQuery) {

    const res = await queryClient.fetchQuery('filter-my-request', () =>
      GET(`${api.getMyRequest}?${encode(query)}`),
    );
    setListsRequest(res?.data?.results);
    return res?.data;
  }

  async function getWorkingDays(data: absenceType) {
    return await POST(api.getWorkingDays, data);
  }
  async function createWorkPolicy(data: object) {
    return await POST(api.createWorkShiftPolicy, data);
  }
  async function createPublicHoliday(data: any) {
    return await POST(api.createPublicHoliday, data);
  }

  async function getExistUser() {
    return await GET(api.existUser);
  }

  async function getUserPrefence() {
    let result = null;
    try {
      const res = await GET(api.getUserPreference);
      result = res?.data;
    } catch (error) {
      result = error;
    }
    return result;
  }

  async function filterHolidayCalendar(params?: ParsedUrlQuery) {
    let result = null;
    try {
      const res = await queryClient.fetchQuery('filter-holiday', () =>
        GET(`${api.getPublicHoliday}?${encode(params)}`),
      );

      if (res.status === 200) {
        setState((pre) => ({
          ...pre,
          holidayFilter: res?.data?.results,
        }));
        result = res?.data;
      }
    } catch (error) {
      result = error;
      console.log('error', error);
    }
    return result;
  }
  async function filterHolidayCalendarOption() {
    const res = await GET('/api/public_holiday_calendar/option/');

    return await res?.data;
  }
  async function getFilterModal(query: ParsedUrlQuery) {
    return GET(`${api.getBoardingModel}?${encode(query)}`);
  }

  async function getCustomizeDesign() {
    const res = await GET(api.getCustomizeConfiguration);
    return res?.data;
  }

  async function getPublicHolidayById(id: string) {
    const res = await GET(`${api.getPublicHoliday}${id}/`);
    return res?.data;
  }
  async function getStaffLeaveProfileById(id: string) {
    const res = await GET(`${api.staffLeaveList}${id}/`);
    return res?.data;
  }
  async function getWorkShiftCalendarById(id: string) {
    const res = await GET(`${api.workShiftList}${id}/`);
    return res?.data;
  }
  async function getAbsenceTypeById(id: string) {
    const res = await GET(`${api.getAbsenceTypes}${id}/`);
    return res?.data;
  }

  async function getBoardingModelOption() {
    return await GET(api.getBoardingModelOption);
  }

  async function getTaskOption() {
    return await GET(api.getTasksOption);
  }

  async function selectBoardingModel(url: any, data: any) {
    return await PUT(url, data);
  }

  async function launchBoarding(boarding_id: string) {
    return await PUT(`/api/boarding/${boarding_id}/launch/`);
  }

  async function updateActiveTask(data: any) {
    return await PUT(api.updateActiveTask, data);
  }

  async function deleteActiveTask(params: ParsedUrlQuery) {
    return DELETE(`${api.deleteActiveTask}?${encode(params)}`);
  }

  async function getBoardingById(param?) {
    return await GET(`${api.getListBoarding}${param}`);
  }

  async function createAbsenceRequest(data: absenceType) {
    return await POST(api.createAbsenceRequest, data);
  }
  async function createTask(data: createTaskType) {
    return await POST(api.createTask, data);
  }
  async function createActiveTask(data: createActiveTask) {
    return await POST(api.createActiveTask, data);
  }
  async function createModal(data: createTaskType) {
    return await POST(api.createModal, data);
  }

  async function createStaffTypes(params: any) {
    return await POST(api.createAbsenceType, params);
  }

  async function createDepartment(params: any) {
    return await POST(api.createDepartment, params);
  }
  async function createService(params: any) {
    return await POST(api.createService, params);
  }
  async function createLeaveProfile(params: any) {
    return await POST(api.createLeaveProfile, params);
  }
  async function updateCustomizeDesign(params: any) {
    return await POST(api.updateCustomizeDesign, params);
  }

  return {
    createLeaveProfile: createLeaveProfile,
    workShiftListFilter: workShiftListFilter,
    getWorkshiftList: getWorkshiftList,
    getStaffLeaveList: getStaffLeaveList,
    getStaffLeaveListOption: getStaffLeaveListOption,
    departmentList: departmentList?.data?.data,
    getUsersList: getUsersList,
    listRequest: listsRequest,
    getFilterWorkShiftCalendars: getFilterWorkShiftCalendars,
    filterHolidayCalendar: filterHolidayCalendar,
    holidayFilter: holidayFilter,
    getFilterUsers: getFilterUsers,
    createDepartment: createDepartment,
    getUserById: getUserById,
    getService: getService,
    getWorkshiftListOption: getWorkshiftListOption,
    serviceList: serviceList,
    getAbsenceTypeById: getAbsenceTypeById,
    getManagers: getManagers,
    getWorkingDays: getWorkingDays,
    getAbsenceTypesList: getAbsenceTypesList,
    getAbsenceTypesListAll: getAbsenceTypesListAll,
    createService: createService,
    updateCustomizeDesign: updateCustomizeDesign,
    absenceTypes: absenceTypes,
    getExistUser: getExistUser,
    getListRequestApproval: getListRequestApproval,
    getUserPrefence: getUserPrefence,
    getAbsenceCalendar: getAbsenceCalendar,
    absenceRequestCalendar: absenceRequestCalendar,
    getMyBalanceOption: getMyBalanceOption,
    filterHolidayCalendarOption: filterHolidayCalendarOption,
    getWorkShiftCalendarById: getWorkShiftCalendarById,
    getStaffLeaveProfileById: getStaffLeaveProfileById,
    createAbsenceRequest: createAbsenceRequest,
    getPublicHolidayById: getPublicHolidayById,
    createTask: createTask,
    createActiveTask: createActiveTask,
    createModal: createModal,
    getServiceList: getServiceList,
    selectBoardingModel: selectBoardingModel,
    launchBoarding: launchBoarding,
    updateActiveTask: updateActiveTask,
    getBoardingById: getBoardingById,
    getCustomizeDesign: getCustomizeDesign,
    createWorkPolicy: createWorkPolicy,
    createPublicHoliday: createPublicHoliday,
    createStaffTypes: createStaffTypes,
    getAbsenceBalance: getAbsenceBalance,
    filterListRequest: filterListRequest,
    getFilterTasks: getFilterTasks,
    users: users,
    setMemberState: setState,
    getAllActiveTask: getAllActiveTask,
    getTaskOption: getTaskOption,
    getBoardingModelOption: getBoardingModelOption,
    getFilterModal: getFilterModal,
    getFilterListBoarding: getFilterListBoarding,
    deleteActiveTask: deleteActiveTask,
  };
};

export default useMember;
